import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bag-3, luggage, suitcase, work"} maskId="square-filled-radius-0-stroke-1-IconBag3"><path d="M22 21H2V11.4053L11.5 13.4053V14.5H12.5V13.4053L22 11.4053V21Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M17 6H22V10.3828L12.5 12.3828V11.5H11.5V12.3828L2 10.3828V6H7V2H17V6ZM8 6H16V3H8V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBag3;
